import React, { useEffect } from 'react'
import { motion } from 'framer-motion';
import { useAppDispatch, useAppSelector } from '../../../hooks/useAppDispatch.js'
import { fetchPageBySlug } from '../../../redux/slices/cmsSlice.js'
import './TermsAndConditions.scss';

const TermsAndConditions = () => {
    // Get data from Redux store
    const dispatch = useAppDispatch()
    const { currentPage: termsPage, loading: pageLoading } = useAppSelector((state) => state.cms)

    useEffect(() => {
        dispatch(fetchPageBySlug('terms'))
    }, [dispatch])

    const getSectionData = (sectionKey) => {
        return termsPage?.sections?.find(section => section.key === sectionKey)?.data
    }

    const heroSection = getSectionData('hero')

    // Show skeleton loading while page is loading and no data yet
    if (pageLoading && !termsPage) {
        return (
            <section className="terms-conditions-section">
                <div className="terms-conditions-container">
                    {/* Skeleton for main heading */}
                    <div className="main-heading-section">
                        <div className="h-10 bg-black-200 rounded w-3/4 mb-8 animate-pulse"></div>
                    </div>

                    {/* Skeleton for description */}
                    <div className="h-6 bg-black-200 rounded w-full mb-12 animate-pulse"></div>

                    {/* Skeleton for terms cards */}
                    <div className="terms-cards-container">
                        {[...Array(3)].map((_, index) => (
                            <div key={index} className="term-card animate-pulse">
                                <div className="h-8 bg-black-200 rounded w-2/3 mb-4"></div>
                                <div className="space-y-2">
                                    <div className="h-4 bg-black-200 rounded w-full"></div>
                                    <div className="h-4 bg-black-200 rounded w-5/6"></div>
                                    <div className="h-4 bg-black-200 rounded w-4/5"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        )
    }

    // Don't render anything if no heroSection data
    if (!heroSection) {
        return null;
    }

    return (
        <section className="terms-conditions-section">
            <div className="terms-conditions-container">
                {/* Main Heading */}
                <motion.div
                    className="main-heading-section"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h1 className="main-heading">{heroSection?.Heading}</h1>
                </motion.div>

                <motion.h2
                    className="term-description mb-5"
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                >
                    {heroSection?.Subheading}
                </motion.h2>

                {/* Terms Cards */}
                <div className="terms-cards-container">
                    {heroSection?.cards?.map((card, index) => (
                        <motion.div
                            key={index}
                            className="term-card"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                        >
                            {card.heading && (
                                <motion.h2
                                    className="term-heading"
                                    initial={{ opacity: 0, x: -10 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.4, delay: index * 0.1 + 0.1 }}
                                >
                                    {card.heading}
                                </motion.h2>
                            )}
                            <motion.p
                                className="term-description"
                                initial={{ opacity: 0, x: -10 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: index * 0.1 + 0.2 }}
                            >
                                {card.subHeading}
                            </motion.p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TermsAndConditions;